import React from 'react';
import { SYSTEM_ADMIN_PATH } from '../../../../constants';

const TrainingProductReports = React.lazy(() => import('./index'));

const routes = {
     path: SYSTEM_ADMIN_PATH.TRAINING_PRODUCT_REPORTS,
     breadcrumb: 'Training Product Reports',
     element: <TrainingProductReports />,
};

export default routes;
